import React from 'react'
import {
  FormattedDate,
  FormattedTime,
  FormattedMessage,
  useIntl,
} from 'react-intl'
import FileIcon from 'components/FileIcon'
import Icon from 'components/Icon'
import messages from './messages'
import classNames from 'classnames'

const Delivery = ({ timestamp, body, title, last, meta, onRefetch }) => {

  const { formatDate, formatTime } = useIntl()
  const { files = [], url } = meta
  const dateTime = new Date(timestamp * 1000);

  const groupedFiles = files.reduce((acc, file) => {
    const { supplierUserIds } = file;
    if (!acc[supplierUserIds]) {
      acc[supplierUserIds] = [];
    }
    acc[supplierUserIds].push(file);
    return acc;
  }, {});

  return (
    <li>
      <div className="relative pb-8">
        { !last &&
          <span className="absolute top-5 left-5 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        }
        <div className="relative flex items-start space-x-3">
          <div>
            <div className="relative px-2 mt-2">
              <div className="h-6 w-6 bg-positive rounded-full ring-4 ring-white flex justify-center items-center">
                <Icon icon="check" className="text-xs text-white" />
              </div>
            </div>
          </div>
          <div className="min-w-0 flex-1 py-0">
            <div className="text-sm leading-6">
              <div className="border border-gray-200 rounded-sm mb-2">
                <div className="p-2 flex justify-between items-center">
                  <span>{ title }</span>
                </div>

                {Object.entries(groupedFiles).map(([supplierUserIds, supplierFiles]) => (
                  <div key={supplierUserIds} className="py-2">
                    <div className="p-2 text-sm font-bold font-mono break-all border-t border-gray-200">{supplierUserIds}</div>
                    <div className="space-y-4">
                      {supplierFiles.map(({ id, name, url, timestamp, revised, review }) => {
                        const dateTime = new Date(timestamp * 1000);
                        return (
                          <div
                            key={id}
                            className={classNames('p-2 space-y-2', {
                              'bg-yellow-50': revised,
                              'bg-red-50': review.status === 'DECLINED',
                            })}
                          >
                            <div
                              className={classNames('text-xs font-medium font-mono break-all', {
                                'line-through': review.status === 'DECLINED',
                              })}
                              title={name}
                            >
                              {name}
                            </div>
                            <div className="flex justify-between items-center text-xs">
                              <div className="flex space-x-1 text-gray-500">
                                <FileIcon filename={name} />
                                <div>
                                  <FormattedDate value={dateTime} />
                                </div>
                                <div>
                                  <FormattedTime value={dateTime} />
                                </div>
                                {revised && (
                                  <div className="font-medium">
                                    &middot; <FormattedMessage {...messages.revised} />
                                  </div>
                                )}
                              </div>
                              <span className="space-x-2">
                                {review.status === 'APPROVED' ? (
                                  <Icon icon="check" className="text-positive" title="Approved" />
                                ) : review.status === 'PENDING' ? (
                                  <Icon icon="circle" className="text-gray-400" title="Pending" />
                                ) : (
                                  <Icon icon="times" className="text-negative" title={review.comment} />
                                )}
                              </span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
              <span className="whitespace-nowrap text-gray-500 text-xs" title={`${formatDate(dateTime)} ${formatTime(dateTime)}`}>
                <FormattedDate value={timestamp * 1000} /> <FormattedTime value={timestamp * 1000} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}
export default Delivery
